export default "__VITE_ASSET__D_qY5Nko__"